import { get, postCustomToken, post, postForm, put } from "../apiUtil";
/**
 * Import all constants as an object.
 */
import * as actionType from 'constants/actionType';
//import * as notificationsAction from '../actions/shared/notificationActions';
import appConstant from 'constants/app';
import * as storage from '../../utility/storage';
import { notificationService } from "../../notifications/NotificationService"
import _ from "lodash"
import { splitCamelCase } from '../../utility/utils'

export const getClientDetail = (refId) => {
    return (dispatch) => {
        get(process.env.REACT_APP_API_URL, 'client/' + refId + '/details/basic')
            .then((response) => {
                const detail = { success: true, receiveObj: response.data };
                storage.setSessionStorage(appConstant.clientDetail, detail)
                dispatch({
                    type: actionType.CLIENT_DETAIL_SUCCESS,
                    payload: detail
                });

            })
            .catch((error) => {
                notificationService.sendMessage("There was an error. Please try again. You can contact us at support@debtonator.us if the problem persists.", "danger", "");
                dispatch({
                    type: actionType.CLIENT_DETAIL_FAIL,
                    payload: { success: false, receiveObj: error }
                });
            });
    }
}

export const getDMClientBasicDetail = (refId) => {
    return (dispatch) => {
        get(process.env.REACT_APP_API_URL, 'client/' + refId + '/dm/basic/detail')
            .then((response) => {
                const detail = { success: true, receiveObj: response.data };
                dispatch({
                    type: actionType.DM_CLIENT_DETAIL_SUCCESS,
                    payload: detail
                });

            })
            .catch((error) => {
                notificationService.sendMessage("There was an error. Please try again. You can contact us at support@debtonator.us if the problem persists.", "danger", "");
                dispatch({
                    type: actionType.CLIENT_DETAIL_FAIL,
                    payload: { success: false, receiveObj: error }
                });
            });
    }
}



export const getClientDetailCore = (refId) => {

    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'client/' + refId + '/details/basic')
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                notificationService.sendMessage("There was an error while loading permissions. Please try again. You can contact us at support@debtonator.us if the problem persists.", "danger", "");
                return resolve({ success: false, receiveObj: error })
            });

    });
}

export const loadClientDetail = (refId) => {

    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'client/' + refId + '/details/basic')
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                notificationService.sendMessage("There was an error while loading permissions. Please try again. You can contact us at support@debtonator.us if the problem persists.", "danger", "");
                return resolve({ success: false, receiveObj: error })
            });

    });
}

export const getClientPermission = (refId) => {

    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'client/' + refId + '/permissions')
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                notificationService.sendMessage("There was an error while loading permissions. Please try again. You can contact us at support@debtonator.us if the problem persists.", "danger", "");
                return resolve({ success: false, receiveObj: error })
            });

    });

}

export const getAssignments = (refId) => {

    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'client/' + refId + '/assignments')
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {

                return resolve({ success: false, receiveObj: error })
            });

    });

}

export const getDocuments = (refId) => {

    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'client/' + refId + '/documents')
            .then((response) => {

                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {

                return resolve({ success: false, receiveObj: error })
            });

    });
}


export const getRecentlyAccessedClients = () => {
    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'clients/recent')
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })

            });
    });
}

export const getRecentlyAccessedClientsFor = (userId) => {
    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'clients/recent/user/' + userId)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })

            });
    });
}

export const getScoreSummary = (refId, showNotification) => {
    return (dispatch) => {
        get(process.env.REACT_APP_API_URL, 'credit/' + refId + '/score', true)
            .then((response) => {

                let obj = {
                    isApplicant: false,
                    IsCoApp: false,
                    applicant: {
                        score_value: "", score_date: "", collection: []
                    },
                    coapp: {
                        score_value: "", score_date: "", collection: []
                    },
                    showNotification: false
                }

                const applicant = response.data.primary;
                const coapp = response.data.coapp;

                if (applicant != null) {

                    obj.isApplicant = true
                    _.forEach(applicant.collection, (value, key) => {
                        obj.applicant.collection.push({ "name": splitCamelCase(key), "value": value });
                    });


                    obj.applicant.score_date = applicant.score_date;
                    obj.applicant.score_value = applicant.score_value;
                    obj.showNotification = showNotification;
                }

                if (coapp != null) {

                    obj.IsCoApp = true

                    _.forEach(coapp.collection, (value, key) => {
                        obj.coapp.collection.push({ "name": splitCamelCase(key), "value": value });
                    });

                    obj.coapp.score_date = applicant.score_date;
                    obj.coapp.score_value = applicant.score_value;
                    obj.showNotification = showNotification;
                }



                dispatch({
                    type: actionType.CLIENT_SCORE_SUMMARY,
                    payload: obj
                });

            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: actionType.CLIENT_SCORE_SUMMARY_RESET,
                    payload: {
                        isApplicant: false,
                        IsCoApp: false,
                        appCollection: [],
                        coappCollection: [],
                        showNotification: false
                    }
                });
            });
    }
}

export const getStateAttorneyCom = (stateCode) => {
    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'jwf/' + stateCode)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })

            });
    });
}

export const getClient = (searchInfo, token) => {
    return new Promise((resolve) => {
        postCustomToken(process.env.REACT_APP_API_URL, `clients/search`, token, searchInfo)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
}

export const getClientByRefIdMail = (id) => {
    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'mailing/byid/' + id)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
}

export const getClientByLastZipMail = (lastName, zip) => {
    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'mailing/search/?last=' + lastName + '&zip=' + zip)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
}

export const convertToClient = (Id) => {
    return new Promise((resolve) => {
        post(process.env.REACT_APP_API_URL, 'jwf/mailing/client/' + Id)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
}

export const getSummaryLoans = (refId) => {
    return (dispatch) => {
        get(process.env.REACT_APP_API_URL, 'client/' + refId + '/loans')
            .then((response) => {
                let detail = []
                detail = { loans: response.data.loans, isLoanHit: true };
                dispatch({
                    type: actionType.CLIENT_SMMARY_LOAN,
                    payload: detail
                });

            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: actionType.CLIENT_SUMMARY_LOAN_RESET,
                    payload: { detail: [] }
                });
            });
    }
}

export const resetWorkingStatus = (clientId, obj) => {
    return new Promise((resolve) => {
        post(process.env.REACT_APP_API_URL, 'client/' + clientId + '/contract/resettoworking', obj)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
}

export const updateContractStatus = (ref, data) => {
    return new Promise((resolve) => {
        postForm(process.env.REACT_APP_API_URL, 'client/' + ref + '/contract/status', data)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
}

export const canTransferToNewCompany = (ref, newCode) => {
    return new Promise((resolve) => {
        post(process.env.REACT_APP_API_URL, `jwf/client/${ref}/can_transfer_to/${newCode}`)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data });
            });
    });
}

export const getClientSearch = (searchInfo) => {
    return new Promise((resolve) => {
        post(process.env.REACT_APP_API_URL, `clients/search`, searchInfo)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
}

export const convertToClientWithCustomToken = (Id, token) => {
    return new Promise((resolve) => {
        postCustomToken(process.env.REACT_APP_API_URL, 'jwf/mailing/client/' + Id, token)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });

    });
}


export const transferToNewCompany = (ref, payload) => {
    return new Promise((resolve) => {
        post(process.env.REACT_APP_API_URL, `jwf/client/${ref}/transfer`, payload)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });
    });
}

export const getPin = (obj) => {
    return new Promise((resolve) => {
        post(process.env.REACT_APP_API_URL, `/manager/token/retrieve`, obj)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });
    });
}

export const updateStatusToWorking = (ref, payload) => {
    return new Promise((resolve) => {
        put(process.env.REACT_APP_API_URL, `client/${ref}/opencontract/assigntoself`, null)
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })
            });
    });
}


export const getSalesPipelineClients = () => {
    return new Promise((resolve) => {
        get(process.env.REACT_APP_API_URL, 'clients/sales/pipeline')
            .then((response) => {
                return resolve({ success: true, receiveObj: response.data })
            })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error })

            });
    });
}
